import '@shell/shell-ui/src/scss/main.scss';
import 'regenerator-runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import { ToastContainer } from 'react-toastify';

import store from '@redux/store';
import App from './app';

const instance = createInstance({
  urlBase: MATOMO_URL,
  siteId: window.location.host === 'app.shellgids.com' ? 1 : 2,
  trackerUrl: `${MATOMO_URL}/matomo.php`,
  srcUrl: `${MATOMO_URL}/matomo.js`,
});

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
  <React.StrictMode>
    <MatomoProvider value={instance}>
      <Provider store={store}>
        <App />
        <ToastContainer
          autoClose={2000}
          limit={5}
        />
      </Provider>
    </MatomoProvider>
  </React.StrictMode>,
);
